
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { NoticeId, NoticeId_$reflection } from "../Shared/Shared.js";
import { record_type, bool_type, class_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { compare, now, toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { curry2, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { iterate, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Pencil from "../../public/assets/icons/Pencil.svg";
import { isEmpty, filter, sortBy, map, length, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import Delete_1 from "../../public/assets/icons/Delete_1.svg";
import { ImageViewer } from "../Components/ImageViewer.js";
import Padlock_Square_1 from "../../public/assets/icons/Padlock_Square_1.svg";
import { useTranslation } from "react-i18next";
import { map as map_1, unwrap, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import Upload_File from "../../public/assets/icons/Upload_File.svg";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { Toggle } from "../Components/Toggle.js";
import { Button, IconButton } from "../Components/Button.js";
import { TextArea } from "../Components/TextArea.js";
import Send_Email from "../../public/assets/icons/Send_Email.svg";
import Check from "../../public/assets/icons/Check.svg";

export class Message extends Record {
    constructor(Id, Message, ImageUrl, Timestamp, SenderName, SenderId, IsVisibleForUser) {
        super();
        this.Id = Id;
        this.Message = Message;
        this.ImageUrl = ImageUrl;
        this.Timestamp = Timestamp;
        this.SenderName = SenderName;
        this.SenderId = SenderId;
        this.IsVisibleForUser = IsVisibleForUser;
    }
}

export function Message_$reflection() {
    return record_type("Widgets.ChatWidget.Message", [], Message, () => [["Id", NoticeId_$reflection()], ["Message", string_type], ["ImageUrl", option_type(string_type)], ["Timestamp", class_type("System.DateTime")], ["SenderName", string_type], ["SenderId", string_type], ["IsVisibleForUser", bool_type]]);
}

function MessageComponent(props) {
    let elems_9, elems_8, elems_7, elems_3, elems_2, elems_4, elems_6;
    const patternInput = reactApi.useState(false);
    const setIsImageViewerOpen = patternInput[1];
    const timestampString = toString(toLocalTime(props.Message.Timestamp), "dd.MM.yyyy, HH:mm");
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-end"), delay(() => ((props.UserId === props.Message.SenderId) ? singleton("justify-end") : empty()))))))))], (elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col-reverse"), delay(() => append(singleton("rounded"), delay(() => append(singleton("w-3/5"), delay(() => append(singleton("mb-4"), delay(() => ((props.UserId === props.Message.SenderId) ? singleton("bg-primary") : singleton("bg-background")))))))))))))))], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("p-4"), delay(() => append(singleton("font-normal"), delay(() => ((props.UserId === props.Message.SenderId) ? singleton("text-white") : empty()))))))))))))], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-between"])], (elems_3 = [reactElement("span", {
        className: join(" ", ["text-base"]),
        children: props.Message.Message,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-between"])], (elems_2 = toList(delay(() => {
        let elems;
        return append(props.CanEdit ? singleton(reactElement("div", createObj(ofArray([["onClick", (_arg) => {
            props.OnEditClicked(props.Message);
            props.SetIsEdit(true);
        }], ["className", join(" ", ["h-4", "w-4", "text-white", "cursor-pointer"])], (elems = [Pencil()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
            let elems_1;
            if (props.CanDelete) {
                const matchValue = props.OnDeleteClicked;
                if (matchValue == null) {
                    return empty();
                }
                else {
                    const onDeleteClicked = matchValue;
                    return singleton(reactElement("div", createObj(ofArray([["onClick", (_arg_1) => {
                        onDeleteClicked(props.Message);
                    }], ["className", join(" ", toList(delay(() => append(singleton("ml-4"), delay(() => append(singleton("h-4"), delay(() => append(singleton("w-4"), delay(() => append(singleton("cursor-pointer"), delay(() => ((props.UserId === props.Message.SenderId) ? singleton("text-white") : singleton("text-black")))))))))))))], (elems_1 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                }
            }
            else {
                return empty();
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "w-96"])], (elems_4 = toList(delay(() => {
        const matchValue_1 = props.Message.ImageUrl;
        if (matchValue_1 != null) {
            const imageUrl = matchValue_1;
            return append(singleton(reactElement("img", {
                className: join(" ", ["cursor-pointer", "h-64", "object-cover"]),
                src: imageUrl,
                onClick: (_arg_2) => {
                    setIsImageViewerOpen(true);
                },
            })), delay(() => singleton(ImageViewer({
                Images: singleton_1({
                    Src: imageUrl,
                }),
                IsOpen: patternInput[0],
                OnClose: () => {
                    setIsImageViewerOpen(false);
                },
            }))));
        }
        else {
            return empty();
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mt-4"])], (elems_6 = toList(delay(() => {
        let elems_5;
        return append((!props.Message.IsVisibleForUser && props.CanEdit) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4", "mr-3"])], (elems_5 = [Padlock_Square_1()], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => singleton(reactElement("span", {
            className: join(" ", ["font-medium", "text-sm"]),
            children: concat(timestampString, " Uhr - ", ...props.Message.SenderName),
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

export function ChatWidget(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const emptyMessage = new Message(new NoticeId("00000000-0000-0000-0000-000000000000"), "", undefined, now(), "", "", false);
    const patternInput_1 = reactApi.useState(emptyMessage);
    const setEditMessage = patternInput_1[1];
    const editMessage = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const setNewMessage = patternInput_2[1];
    const newMessage = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setNewImage = patternInput_3[1];
    const newImage = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setImagePreviewUrl = patternInput_4[1];
    const imagePreviewUrl = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const setIsDragOver = patternInput_5[1];
    const fileInputRef = reactApi.useRef(undefined);
    const submitInProgressRef = reactApi.useRef(false);
    const removeImage = () => {
        iterate((arg) => {
            URL.revokeObjectURL(arg);
        }, toArray(imagePreviewUrl));
        setNewImage(undefined);
        setImagePreviewUrl(undefined);
    };
    const selectImage = (file) => {
        iterate((arg_1) => {
            URL.revokeObjectURL(arg_1);
        }, toArray(imagePreviewUrl));
        submitInProgressRef.current = false;
        setNewImage(file);
        setImagePreviewUrl(URL.createObjectURL(file));
    };
    const chatboxRef = reactApi.useRef(undefined);
    const scrollToBottom = () => {
        iterate((el) => {
            el.scrollTop = el.scrollHeight;
        }, toArray(chatboxRef.current));
    };
    const dependencies = [length(props.Messages)];
    reactApi.useEffect(() => {
        setNewMessage("");
        removeImage();
        setIsDragOver(false);
        submitInProgressRef.current = false;
        scrollToBottom();
        window.setTimeout((_arg_1) => {
            scrollToBottom();
        }, 50);
        window.setTimeout((_arg_2) => {
            scrollToBottom();
        }, 350);
    }, dependencies);
    const dependencies_2 = [props.IsSubmitting];
    reactApi.useEffect(() => {
        if (!props.IsSubmitting) {
            submitInProgressRef.current = false;
        }
    }, dependencies_2);
    const patternInput_6 = reactApi.useState(false);
    const setIsEdit = patternInput_6[1];
    const isEdit = patternInput_6[0];
    let canUserWriteAMessage;
    const matchValue = props.UserData.Role;
    switch (matchValue) {
        case "user": {
            const matchValue_1 = props.CustomerConfiguration;
            canUserWriteAMessage = ((matchValue_1 == null) ? false : matchValue_1.CanUserWriteNotices);
            break;
        }
        default:
            canUserWriteAMessage = true;
    }
    const messages = map((m_1) => createElement(MessageComponent, {
        CanDelete: (m_1.SenderId === props.UserData.UserId) ? true : (props.UserData.Role === "administrator"),
        CanEdit: (props.OnEditClicked != null) && (m_1.SenderId === props.UserData.UserId),
        Message: m_1,
        OnDeleteClicked: unwrap(props.OnDeleteClicked),
        OnEditClicked: setEditMessage,
        SetIsEdit: setIsEdit,
        UserId: props.UserId,
    }), sortBy((m) => m.Timestamp, filter((message) => {
        const matchValue_2 = props.UserData.Role;
        switch (matchValue_2) {
            case "user":
                return message.IsVisibleForUser;
            default:
                return true;
        }
    }, props.Messages), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const elements = isEmpty(messages) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-background", "p-2", "w-1/4", "rounded", "text-center"])], (elems = [t("general.no_content")], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : messages;
    const isDropEnabled = (((props.CanUploadImage && (props.OnSubmit != null)) && canUserWriteAMessage) && !isEdit) && !props.IsSubmitting;
    return reactElement("div", createObj(toList(delay(() => append(singleton(["className", join(" ", ["flex", "flex-col", "justify-between", "grow", "h-full", "relative"])]), delay(() => append(isDropEnabled ? append(singleton(["onDragOver", (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(true);
    }]), delay(() => append(singleton(["onDragLeave", (e_1) => {
        e_1.preventDefault();
        e_1.stopPropagation();
        setIsDragOver(false);
    }]), delay(() => singleton(["onDrop", (e_2) => {
        e_2.preventDefault();
        e_2.stopPropagation();
        setIsDragOver(false);
        const files = e_2.dataTransfer.files;
        if (files.length > 0) {
            const file_1 = files[0];
            if (file_1.type.startsWith("image/")) {
                selectImage(file_1);
            }
        }
    }]))))) : empty(), delay(() => {
        let elems_28;
        return singleton((elems_28 = toList(delay(() => {
            let elems_4, elems_3, elems_2;
            return append((isDropEnabled && patternInput_5[0]) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "inset-0", "z-10", "bg-primary/10", "border-2", "border-dashed", "border-primary", "rounded-lg", "flex", "items-center", "justify-center", "pointer-events-none"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "gap-2"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-10", "w-10", "text-primary"])], (elems_2 = [Upload_File()], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("span", {
                className: join(" ", ["text-primary", "font-medium", "text-sm"]),
                children: t("chat.drop_image_here"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => {
                let elems_6;
                return append(singleton(reactElement("div", createObj(ofArray([["id", "chatbox"], ["ref", (el_1) => {
                    if (!Operators_IsNull(el_1)) {
                        chatboxRef.current = el_1;
                    }
                }], ["className", join(" ", ["flex", "flex-col", "space-y-4", "overflow-y-auto", "scrollbar-thumb-blue", "scrollbar-thumb-rounded", "scrollbar-track-blue-lighter", "scrollbar-w-2", "scrolling-touch", props.MaxContentHeigth])], (elems_6 = [reactElement("div", {
                    id: "messages",
                    className: join(" ", []),
                    children: reactApi.Children.toArray(Array.from(elements)),
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                    let elems_27;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "mt-8", "print:hidden"])], (elems_27 = toList(delay(() => {
                        let matchValue_3, userVisibility, elems_7, matchValue_4, elems_26, elems_18, matchValue_9, elems_17, elems_15, elems_16, elems_25, elems_19, elems_24, elems_21, elems_20, elems_23, elems_22;
                        if (!isEdit) {
                            if (canUserWriteAMessage) {
                                return append((matchValue_3 = props.UserVisibility, (matchValue_3 == null) ? (empty()) : ((userVisibility = matchValue_3, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "mb-2"])], (elems_7 = [createElement(Toggle, {
                                    Checked: !userVisibility.IsVisibleForUserChecked,
                                    OnChange: (matchValue_4 = props.UserData.Role, (matchValue_4 === "toolManager") ? ((arg_2) => {
                                        userVisibility.OnVisibleForUserChecked(!arg_2);
                                    }) : ((matchValue_4 === "system") ? ((arg_2) => {
                                        userVisibility.OnVisibleForUserChecked(!arg_2);
                                    }) : ((matchValue_4 === "user") ? ((value_32) => {
                                    }) : ((arg_2) => {
                                        userVisibility.OnVisibleForUserChecked(!arg_2);
                                    })))),
                                    RightLabel: t("notice.hide_notice_from_user"),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))))))), delay(() => {
                                    let elems_14;
                                    const matchValue_5 = props.OnSubmit;
                                    if (matchValue_5 == null) {
                                        return empty();
                                    }
                                    else {
                                        const onSubmit = map_1(curry2, matchValue_5);
                                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_14 = toList(delay(() => {
                                            let matchValue_6, previewUrl, elems_9, elems_8;
                                            return append((matchValue_6 = imagePreviewUrl, (matchValue_6 == null) ? (empty()) : ((previewUrl = matchValue_6, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["relative", "w-24", "mb-2"])], (elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "top-1", "right-1", "h-5", "w-5", "p-1", "rounded-full", "text-red", "bg-background", "cursor-pointer"])], ["onClick", (_arg_4) => {
                                                if (!props.IsSubmitting) {
                                                    removeImage();
                                                }
                                            }], (elems_8 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), reactElement("img", {
                                                className: join(" ", ["shadow", "rounded", "border", "w-24", "h-20", "object-cover"]),
                                                src: previewUrl,
                                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))))))), delay(() => {
                                                let elems_13;
                                                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row"])], (elems_13 = toList(delay(() => {
                                                    let elems_10;
                                                    return append(props.CanUploadImage ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mr-4", "flex", "items-center"])], (elems_10 = [reactElement("input", {
                                                        ref: (el_2) => {
                                                            if (!Operators_IsNull(el_2)) {
                                                                fileInputRef.current = el_2;
                                                            }
                                                        },
                                                        type: "file",
                                                        accept: ".jpg, .jpeg, .png",
                                                        className: join(" ", ["hidden"]),
                                                        onChange: (ev) => {
                                                            const files_1 = ev.target.files;
                                                            if (!(files_1 == null) && (files_1.length > 0)) {
                                                                selectImage(files_1.item(0));
                                                            }
                                                        },
                                                    }), createElement(IconButton, {
                                                        ComponentState: props.IsSubmitting ? "disabled" : "enabled",
                                                        Icon: Upload_File(),
                                                        OnClick: () => {
                                                            const matchValue_7 = fileInputRef.current;
                                                            if (matchValue_7 == null) {
                                                            }
                                                            else {
                                                                const el_3 = matchValue_7;
                                                                el_3.click();
                                                            }
                                                        },
                                                        TestId: "chat-upload-image-button",
                                                    })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty(), delay(() => {
                                                        let elems_11;
                                                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "mr-4"])], (elems_11 = [createElement(TextArea, {
                                                            ComponentState: props.IsSubmitting ? "disabled" : "enabled",
                                                            OnChange: (value_53) => {
                                                                submitInProgressRef.current = false;
                                                                setNewMessage(value_53);
                                                            },
                                                            TestId: "",
                                                            Value: newMessage,
                                                        })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                                                            let elems_12;
                                                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_12 = [createElement(Button, {
                                                                ComponentState: (!props.IsSubmitting && ((newMessage !== "") ? true : (newImage != null))) ? "enabled" : "disabled",
                                                                Icon: Send_Email(),
                                                                Label: "",
                                                                OnClick: () => {
                                                                    if ((!props.IsSubmitting && !submitInProgressRef.current) && ((newMessage !== "") ? true : (newImage != null))) {
                                                                        submitInProgressRef.current = true;
                                                                        onSubmit(newMessage)(newImage);
                                                                        setNewMessage("");
                                                                        removeImage();
                                                                    }
                                                                },
                                                                TestId: "chat-submit-button",
                                                                Variant: "primary",
                                                            })], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
                                                        }));
                                                    }));
                                                })), ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
                                            }));
                                        })), ["children", reactApi.Children.toArray(Array.from(elems_14))])]))));
                                    }
                                }));
                            }
                            else {
                                return empty();
                            }
                        }
                        else {
                            const matchValue_8 = props.OnEditClicked;
                            if (matchValue_8 == null) {
                                return empty();
                            }
                            else {
                                const onEditClicked = matchValue_8;
                                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_26 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-3", "mb-2"])], (elems_18 = [createElement(Toggle, {
                                    Checked: !editMessage.IsVisibleForUser,
                                    OnChange: (matchValue_9 = props.UserData.Role, (matchValue_9 === "toolManager") ? ((_arg_7) => {
                                        setEditMessage(new Message(editMessage.Id, editMessage.Message, editMessage.ImageUrl, editMessage.Timestamp, editMessage.SenderName, editMessage.SenderId, !editMessage.IsVisibleForUser));
                                    }) : ((matchValue_9 === "system") ? ((_arg_7) => {
                                        setEditMessage(new Message(editMessage.Id, editMessage.Message, editMessage.ImageUrl, editMessage.Timestamp, editMessage.SenderName, editMessage.SenderId, !editMessage.IsVisibleForUser));
                                    }) : ((matchValue_9 === "user") ? ((value_61) => {
                                    }) : ((_arg_7) => {
                                        setEditMessage(new Message(editMessage.Id, editMessage.Message, editMessage.ImageUrl, editMessage.Timestamp, editMessage.SenderName, editMessage.SenderId, !editMessage.IsVisibleForUser));
                                    })))),
                                    RightLabel: t("notice.hide_notice_from_user"),
                                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "text-text-muted", "text-sm", "font-semibold"])], (elems_17 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4", "mr-2"])], (elems_15 = [Pencil()], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_16 = toList(delay(() => {
                                    const editTranslation = t("notice.edit_notice");
                                    const clockTranslation = t("general.clock");
                                    return singleton(concat(editTranslation, toString(toLocalTime(editMessage.Timestamp), "dd.MM.yyyy, HH:mm"), " ", ...clockTranslation));
                                })), ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))], ["children", reactApi.Children.toArray(Array.from(elems_18))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "grow"])], (elems_25 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow"])], (elems_19 = [createElement(TextArea, {
                                    ComponentState: "enabled",
                                    OnChange: (message_1) => {
                                        setEditMessage(new Message(editMessage.Id, message_1, editMessage.ImageUrl, editMessage.Timestamp, editMessage.SenderName, editMessage.SenderId, editMessage.IsVisibleForUser));
                                    },
                                    TestId: "",
                                    Value: editMessage.Message,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_19))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "ml-3"])], (elems_24 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "flex", "flex-row"])], (elems_21 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow"])], (elems_20 = [createElement(Button, {
                                    ComponentState: "enabled",
                                    Icon: unwrap(Check()),
                                    Label: "",
                                    OnClick: () => {
                                        onEditClicked(editMessage);
                                        setIsEdit(false);
                                    },
                                    TestId: "",
                                    Variant: "primary",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_20))])])))], ["children", reactApi.Children.toArray(Array.from(elems_21))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "flex", "flex-row"])], (elems_23 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow"])], (elems_22 = [createElement(Button, {
                                    ComponentState: "enabled",
                                    Icon: unwrap(Delete_1()),
                                    Label: "",
                                    OnClick: (message_2) => {
                                        setEditMessage(emptyMessage);
                                        setIsEdit(false);
                                    },
                                    TestId: "",
                                    Variant: "secondary",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_22))])])))], ["children", reactApi.Children.toArray(Array.from(elems_23))])])))], ["children", reactApi.Children.toArray(Array.from(elems_24))])])))], ["children", reactApi.Children.toArray(Array.from(elems_25))])])))], ["children", reactApi.Children.toArray(Array.from(elems_26))])]))));
                            }
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_27))])]))));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_28))]));
    }))))))));
}

